import { Button, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';

const AccountActivationTable = ({
  accounts,
  rowSelectionAccount,
  handleTableChange,
  isLoadActiveLicenseAccount,
  license,
  onDeactivateAccount,
  singleActiveAccount,
  syncLoading,
  syncActivateAccount,
  activateChainAccount,
}) => {
  const { t } = useTranslation();

  const dataSource = React.useMemo(() => {
    return (
      accounts?.data?.map((account) => ({
        ...account,
        key: account.accountId,
      })) ?? []
    );
  }, [accounts?.data]);

  return (
    <Table
      rowClassName={(record) => !record.enabled && 'disabled-row'}
      rowSelection={rowSelectionAccount}
      dataSource={dataSource}
      pagination={accounts && accounts.pagination}
      loading={accounts && accounts.loading}
      onChange={handleTableChange}
      columns={[
        {
          title: t('Full name'),
          dataIndex: 'fullname',
          key: 'fullname_account',
          sorter: (a, b) => (a.fullname ?? '').localeCompare(b.fullname ?? ''),
        },
        {
          title: t('Name'),
          dataIndex: 'username',
          key: 'username_account',
          sorter: (a, b) => (a.username ?? '').localeCompare(b.username ?? ''),
        },
        {
          title: t('State'),
          key: 'log_action',
          width: 130,
          sorter: (a, b) => {
            const dataA = isLoadActiveLicenseAccount.some(
              (id) => id === a.accountId
            )
              ? 'Activating'
              : a.service
                ? 'Activated'
                : 'Not activated';
            const dataB = isLoadActiveLicenseAccount.some(
              (id) => id === b.accountId
            )
              ? 'Activating'
              : b.service
                ? 'Activated'
                : 'Not activated';
            return dataA.localeCompare(dataB);
          },
          render: (account) =>
            isLoadActiveLicenseAccount.some((id) => id === account.accountId) ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$warning}
              >
                {t('Activating')}
              </Tag>
            ) : account.service ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$online}
              >
                {t('Activated')}
              </Tag>
            ) : (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$offline}
              >
                {t('Not activated')}
              </Tag>
            ),
        },
        {
          title: t('Active date'),
          key: 'log_activatedAt',
          dataIndex: 'service',
          sorter: (a, b) =>
            a.service?.activatedAt?.localeCompare(b.service?.activatedAt),
          render: (service) =>
            service?.activatedAt
              ? moment(service.activatedAt).format('DD-MM-YYYY')
              : '',
        },
        {
          title: t('Action'),
          key: 'actions',
          width: 130,
          render: (account) =>
            account.service ? (
              <div
                className="edit-button"
                onClick={() =>
                  onDeactivateAccount(account.fullname, account.accountId)
                }
              >
                <Button danger htmlType="submit">
                  {t('Deactivate')}
                </Button>
              </div>
            ) : (
              <div
                className="edit-button"
                onClick={() => singleActiveAccount(account.accountId)}
              >
                <Button
                  loading={isLoadActiveLicenseAccount.some(
                    (id) => id === account.accountId
                  )}
                  disabled={!license}
                  htmlType="submit"
                >
                  {t('Activate')}
                </Button>
              </div>
            ),
        },
      ]}
      footer={() => (
        <div className="sync-activates">
          <Button
            loading={syncLoading}
            onClick={() => syncActivateAccount()}
            type="primary"
            disabled={
              !license ||
              activateChainAccount.length === 0 ||
              isLoadActiveLicenseAccount.length > 0 ||
              activateChainAccount.length > license.size - license.numberActive
            }
          >
            {t('Sync activates')} ({activateChainAccount.length})
          </Button>
        </div>
      )}
    />
  );
};

export default AccountActivationTable;
